// extracted by css-extract-rspack-plugin
export default {"Table":"QGAIZunQef8qINqx","bordered":"tfyxfHSmSY97c1mX"};